import React, { Component } from 'react';
import { SvgImage } from '.';
import { PropTypes } from 'prop-types';
import { arrowUpIcon } from '../../style/images';
import classNames from 'classnames';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { IconButton as MuiIconButton } from '@mui/material';
import $ from 'jquery';
import { isEqual } from 'lodash';

const Dot = ( { active, onClick, page } ) => {
  const goToPage = () => onClick( page );
  return <div className={ classNames( 'dot', { 'active': active } ) } onClick={ goToPage }/>;
};

export class PageSelector extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      page: 0,
      pages: 0
    };

    this.timeout;
    props.slider && this.onResize();
  }

  componentDidMount() {
    this.mounted = true;
    window.addEventListener( 'resize', this.onResize );
  }

  // componentDidUpdate( prevProps ) {
  //   ( !this.props.slider && prevProps.slider || this.props.children !== prevProps.children ) && this.onResize();
  // }
  componentDidUpdate( prevProps ) {
    ( !this.props.slider && prevProps.slider || this.props.children !== prevProps.children ) && this.onResize();
    ( !this.props.slider && prevProps.slider || this.props.children !== prevProps.children ) && this.calculateNeededPages();
     this.props.totalFilterCount !== prevProps.totalFilterCount && this.setScrollPosition();
     const children = this.props.slider.children || [];
    
     let childElementsWidth = [];
    
     children && children.length && [...children].forEach(c => { childElementsWidth.push( c.clientWidth)});
    
     if(!isEqual(this.state.childElementsWidth, childElementsWidth)) {
    
     this.setState({childElementsWidth : childElementsWidth});
    
      this.onResize();
    
     }
    else if( ( !this.props.slider && prevProps.slider ) || ( this.props.children !== prevProps.children ) ) this.onResize();
      
    }
  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener( 'resize', this.onResize );
  }

  calculateNeededPages = () => {
    const { slider } = this.props;
    if( !slider ) {
      return;
    }
    let newSlider = slider;
    const { page, pages } = this.state;
    const newPages = Math.ceil( newSlider.scrollWidth / newSlider.clientWidth );
    if(pages !== newPages ) {     
      let newPage = Math.round( newPages / pages * page );

      if ( page === pages - 1 || newPage > newPages - 1 ) {
        newPage = newPages - 1;
      } 
      if ( page === 0 || newPage < 0 ) {
        newPage = 0;
      }
      this.props.onPageUpdate && this.props.onPageUpdate( newPages );
      this.mounted && this.setState( { page: newPage, pages: newPages }, this.setScrollPosition );
    }
  }

  goToPage = currentPage => {
    const { page } = this.state;
    page !== currentPage && this.mounted && this.setState( { page: currentPage }, this.setScrollPosition ); 
  }

  nextPage = () => {
    const { page, pages } = this.state;
    this.goToPage( page === pages - 1 ? 0 : page + 1 );
  }

  previousPage = () => {
    const { page, pages } = this.state;
    this.goToPage( page === 0 ? pages - 1 : page - 1 );
  }

  setScrollPosition = () => {
    const { slider } = this.props;
    const { page, pages } = this.state;
    if( !this.mounted ) {
      return;
    }

    if( slider ) {
      const scrollPosition = page === pages - 1 
        ? slider.scrollWidth - slider.clientWidth 
        : slider.clientWidth * page || 0;

      slider.style.left = `-${scrollPosition}px`;
    }
  }

  onResize = () => {
    this.timeout && clearTimeout( this.timeout );
    this.timeout = setTimeout( this.calculateNeededPages, 1 );
  }

  render() {
    const { page, pages } = this.state;
    const dots = [];

    for( let i = 0; i < pages; i++ ) {
      dots.push( <Dot key={ i } active={ page === i } onClick={ this.goToPage } page={ i }/> );
    }

    return pages > 1 && <div className="page-selector">
      {/* <SvgImage source={ arrowUpIcon } className="arrow-left" onClick={ this.previousPage }/> */}
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.previousPage} sx={{width:"24px", height:"24px", "&.MuiButtonBase-root:hover": {
                bgcolor: "transparent"
              }}}><NavigateBefore style={{fill:"#BABABA"}}></NavigateBefore></MuiIconButton>
      <div className="dots">
        { dots }
      </div>
      {/* <SvgImage source={ arrowUpIcon } className="arrow-right" onClick={ this.nextPage }/> */}
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.nextPage} sx={{width:"24px", height:"24px", "&.MuiButtonBase-root:hover": {
                bgcolor: "transparent"
              }}}><NavigateNext style={{fill:"#BABABA"}}></NavigateNext></MuiIconButton>
    </div>;
  }
}

PageSelector.propTypes = {
  children: PropTypes.number,
  onPageUpdate: PropTypes.func,
  slider: PropTypes.instanceOf( Element ).isRequired
};